<div class="dd">

    <!-- ══════════════════════════════════════════════════════════════════════
         Shared header — title/badge on left, controls + close on right
    ══════════════════════════════════════════════════════════════════════════ -->
    <div class="dd__header">

        <!-- Users title + count badge -->
        <div class="dd__title-wrap" *ngIf="data.type === 'users'">
            <h2 class="dd__title">Active Users</h2>
            <span class="dd__badge">{{ (data.users ?? []).length }}</span>
        </div>

        <!-- Feedback title -->
        <h2 class="dd__title" *ngIf="data.type === 'feedback'">Feedback Comments</h2>

        <!-- Questions title + count badge -->
        <div class="dd__title-wrap" *ngIf="data.type === 'questions'">
            <h2 class="dd__title">Questions Asked</h2>
            <span class="dd__badge">{{ filteredQuestionItems.length }}</span>
        </div>

        <!-- Consolidated report title + count badge -->
        <div class="dd__title-wrap" *ngIf="data.type === 'consolidated'">
            <h2 class="dd__title">Consolidated Report</h2>
            <span class="dd__badge">{{ consolidatedTotalCount }}</span>
        </div>

        <div class="dd__header-right">

            <!-- Search input (users only) -->
            <div class="dd__search" *ngIf="data.type === 'users'">
                <span class="material-icons-outlined dd__search-icon">search</span>
                <input
                    type="text"
                    class="dd__search-input"
                    placeholder="Search by name…"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearchChange()"
                    aria-label="Search users by name" />
            </div>

            <!-- Manager filter (users only) -->
            <div class="dd__filter-wrap" *ngIf="data.type === 'users'" (click)="stopProp($event)">
                <button
                    class="dd__filter-btn"
                    [class.dd__filter-btn--active]="!!selectedManager"
                    (click)="toggleManagerDropdown($event)"
                    aria-label="Filter by manager">
                    <span class="material-icons-outlined dd__filter-icon">badge</span>
                    <span class="dd__filter-label">{{ selectedManager || 'All managers' }}</span>
                    <span class="material-icons-outlined dd__filter-caret"
                          [class.dd__filter-caret--open]="managerDropdownOpen">expand_more</span>
                </button>

                <div class="dd__dropdown" *ngIf="managerDropdownOpen">
                    <div class="dd__dropdown-search">
                        <span class="material-icons-outlined">search</span>
                        <input
                            type="text"
                            [(ngModel)]="managerDropdownSearch"
                            placeholder="Search manager…"
                            (click)="stopProp($event)" />
                    </div>
                    <ul class="dd__dropdown-list">
                        <li class="dd__dropdown-item"
                            [class.dd__dropdown-item--active]="!selectedManager"
                            (click)="selectManager(null, $event)">
                            <span class="material-icons-outlined dd__check-icon" *ngIf="!selectedManager">check</span>
                            All managers
                        </li>
                        <li *ngFor="let managerName of dropdownManagerNames"
                            class="dd__dropdown-item"
                            [class.dd__dropdown-item--active]="selectedManager === managerName"
                            (click)="selectManager(managerName, $event)">
                            <span class="material-icons-outlined dd__check-icon"
                                  *ngIf="selectedManager === managerName">check</span>
                            {{ managerName }}
                        </li>
                        <li class="dd__dropdown-noresult" *ngIf="dropdownManagerNames.length === 0">No match</li>
                    </ul>
                </div>
            </div>

            <!-- Filters for feedback view (user + rating) -->
            <ng-container *ngIf="data.type === 'feedback'">
                <!-- User filter -->
                <div class="dd__filter-wrap" (click)="stopProp($event)">
                    <button
                        class="dd__filter-btn"
                        [class.dd__filter-btn--active]="!!selectedUser"
                        (click)="toggleDropdown($event)"
                        aria-label="Filter by user">
                        <span class="material-icons-outlined dd__filter-icon">person</span>
                        <span class="dd__filter-label">{{ selectedUser || 'All users' }}</span>
                        <span class="material-icons-outlined dd__filter-caret"
                              [class.dd__filter-caret--open]="dropdownOpen">expand_more</span>
                    </button>

                    <div class="dd__dropdown" *ngIf="dropdownOpen">
                        <div class="dd__dropdown-search">
                            <span class="material-icons-outlined">search</span>
                            <input
                                type="text"
                                [(ngModel)]="dropdownSearch"
                                placeholder="Search user…"
                                (click)="stopProp($event)" />
                        </div>
                        <ul class="dd__dropdown-list">
                            <li class="dd__dropdown-item"
                                [class.dd__dropdown-item--active]="!selectedUser"
                                (click)="selectUser(null, $event)">
                                <span class="material-icons-outlined dd__check-icon" *ngIf="!selectedUser">check</span>
                                All users
                            </li>
                            <li *ngFor="let name of dropdownUserNames"
                                class="dd__dropdown-item"
                                [class.dd__dropdown-item--active]="selectedUser === name"
                                (click)="selectUser(name, $event)">
                                <span class="material-icons-outlined dd__check-icon"
                                      *ngIf="selectedUser === name">check</span>
                                {{ name }}
                            </li>
                            <li class="dd__dropdown-noresult" *ngIf="dropdownUserNames.length === 0">No match</li>
                        </ul>
                    </div>
                </div>

                <!-- Rating filter -->
                <div class="dd__filter-wrap" (click)="stopProp($event)">
                    <button
                        class="dd__filter-btn"
                        [class.dd__filter-btn--active]="selectedRating !== null"
                        (click)="toggleRatingDropdown($event)"
                        aria-label="Filter by rating">
                        <span class="material-icons-outlined dd__filter-icon">star</span>
                        <span class="dd__filter-label">{{ selectedRating !== null ? selectedRating + ' stars' : 'All ratings' }}</span>
                        <span class="material-icons-outlined dd__filter-caret"
                              [class.dd__filter-caret--open]="ratingDropdownOpen">expand_more</span>
                    </button>

                    <div class="dd__dropdown" *ngIf="ratingDropdownOpen">
                        <ul class="dd__dropdown-list">
                            <li class="dd__dropdown-item"
                                [class.dd__dropdown-item--active]="selectedRating === null"
                                (click)="selectRating(null, $event)">
                                <span class="material-icons-outlined dd__check-icon" *ngIf="selectedRating === null">check</span>
                                All ratings
                            </li>
                            <li *ngFor="let rating of [5, 4, 3, 2, 1]"
                                class="dd__dropdown-item"
                                [class.dd__dropdown-item--active]="selectedRating === rating"
                                (click)="selectRating(rating, $event)">
                                <span class="material-icons-outlined dd__check-icon"
                                      *ngIf="selectedRating === rating">check</span>
                                <span class="dd__rating-option">
                                    <span *ngFor="let star of [1,2,3,4,5]" 
                                          class="material-icons-outlined dd__star-small"
                                          [class.dd__star--on]="star <= rating">star</span>
                                    ({{ rating }})
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </ng-container>

            <!-- Filters for questions view (category + user) -->
            <ng-container *ngIf="data.type === 'questions'">
                <!-- Category filter -->
                <div class="dd__filter-wrap" (click)="stopProp($event)">
                    <button
                        class="dd__filter-btn"
                        [class.dd__filter-btn--active]="selectedCategory !== 'CES Search Agent'"
                        (click)="toggleCategoryDropdown($event)"
                        aria-label="Filter by category">
                        <span class="material-icons-outlined dd__filter-icon">category</span>
                        <span class="dd__filter-label">{{ selectedCategory || 'CES Search Agent' }}</span>
                        <span class="material-icons-outlined dd__filter-caret"
                              [class.dd__filter-caret--open]="categoryDropdownOpen">expand_more</span>
                    </button>

                    <div class="dd__dropdown" *ngIf="categoryDropdownOpen">
                        <div class="dd__dropdown-search">
                            <span class="material-icons-outlined">search</span>
                            <input
                                type="text"
                                [(ngModel)]="categoryDropdownSearch"
                                placeholder="Search category…"
                                (click)="stopProp($event)" />
                        </div>
                        <ul class="dd__dropdown-list">
                            <li *ngFor="let category of categoryDropdownCategories"
                                class="dd__dropdown-item"
                                [class.dd__dropdown-item--active]="selectedCategory === category"
                                (click)="selectCategory(category, $event)">
                                <span class="material-icons-outlined dd__check-icon"
                                      *ngIf="selectedCategory === category">check</span>
                                {{ category }}
                            </li>
                            <li class="dd__dropdown-noresult" *ngIf="categoryDropdownCategories.length === 0">No match</li>
                        </ul>
                    </div>
                </div>

                <!-- User filter -->
                <div class="dd__filter-wrap" (click)="stopProp($event)">
                    <button
                        class="dd__filter-btn"
                        [class.dd__filter-btn--active]="!!selectedQuestionUser"
                        (click)="toggleQuestionDropdown($event)"
                        aria-label="Filter by user">
                        <span class="material-icons-outlined dd__filter-icon">person</span>
                        <span class="dd__filter-label">{{ selectedQuestionUser || 'All users' }}</span>
                        <span class="material-icons-outlined dd__filter-caret"
                              [class.dd__filter-caret--open]="questionDropdownOpen">expand_more</span>
                    </button>

                    <div class="dd__dropdown" *ngIf="questionDropdownOpen">
                        <div class="dd__dropdown-search">
                            <span class="material-icons-outlined">search</span>
                            <input
                                type="text"
                                [(ngModel)]="questionDropdownSearch"
                                placeholder="Search user…"
                                (click)="stopProp($event)" />
                        </div>
                        <ul class="dd__dropdown-list">
                            <li class="dd__dropdown-item"
                                [class.dd__dropdown-item--active]="!selectedQuestionUser"
                                (click)="selectQuestionUser(null, $event)">
                                <span class="material-icons-outlined dd__check-icon" *ngIf="!selectedQuestionUser">check</span>
                                All users
                            </li>
                            <li *ngFor="let email of questionDropdownUserNames"
                                class="dd__dropdown-item"
                                [class.dd__dropdown-item--active]="selectedQuestionUser === email"
                                (click)="selectQuestionUser(email, $event)">
                                <span class="material-icons-outlined dd__check-icon"
                                      *ngIf="selectedQuestionUser === email">check</span>
                                {{ email }}
                            </li>
                            <li class="dd__dropdown-noresult" *ngIf="questionDropdownUserNames.length === 0">No match</li>
                        </ul>
                    </div>
                </div>
            </ng-container>

            <button
                *ngIf="data.type === 'users'"
                class="dd__icon-btn"
                [disabled]="(data.users ?? []).length === 0"
                (click)="downloadUsersAsExcel()"
                aria-label="Download all users as Excel"
                title="Download all users as Excel">
                <span class="material-icons-outlined">download</span>
            </button>

            <button
                *ngIf="data.type === 'questions'"
                class="dd__icon-btn"
                [disabled]="(data.questionItems ?? []).length === 0"
                (click)="downloadQuestionsAsExcel()"
                aria-label="Download all questions as Excel"
                title="Download all questions as Excel">
                <span class="material-icons-outlined">download</span>
            </button>

            <button
                *ngIf="data.type === 'feedback'"
                class="dd__icon-btn"
                [disabled]="((data.allFeedbackItems ?? data.feedbackItems) ?? []).length === 0"
                (click)="downloadFeedbackAsExcel()"
                aria-label="Download all feedback as Excel"
                title="Download all feedback as Excel">
                <span class="material-icons-outlined">download</span>
            </button>

            <button
                *ngIf="data.type === 'consolidated'"
                class="dd__icon-btn"
                [disabled]="(data.managerStats ?? []).length === 0"
                (click)="downloadConsolidatedAsExcel()"
                aria-label="Download consolidated report as Excel"
                title="Download consolidated report as Excel">
                <span class="material-icons-outlined">download</span>
            </button>

            <button class="dd__close" (click)="close()" aria-label="Close">
                <span class="material-icons-outlined">close</span>
            </button>
        </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         USERS VIEW — paginated table
    ══════════════════════════════════════════════════════════════════════════ -->
    <ng-container *ngIf="data.type === 'users'">

        <div class="dd__body">
            <table class="dd__table" aria-label="Active users">
                <colgroup>
                    <col />
                    <col />
                    <col />
                </colgroup>
                <thead>
                    <tr>
                        <th class="dd__th">User Name</th>
                        <th class="dd__th">User Mail</th>
                        <th class="dd__th">Manager Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of pagedUsers" class="dd__row">
                        <td class="dd__td">
                            <div class="dd__name-cell">
                                <span class="dd__avatar">{{ getInitials(user.name) }}</span>
                                <span class="dd__name">{{ user.name }}</span>
                            </div>
                        </td>
                        <td class="dd__td">
                            <span class="dd__email">{{ user.email }}</span>
                        </td>
                        <td class="dd__td">
                            <span class="dd__manager">{{ user.manager_name || '-' }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div *ngIf="pagedUsers.length === 0" class="dd__empty">
                <span class="material-icons-outlined">person_search</span>
                <p>No users match <strong>"{{ searchTerm }}"</strong></p>
            </div>
        </div>

        <!-- Pagination footer -->
        <div class="dd__footer" *ngIf="totalCount > 0">
            <span class="dd__range">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }}</span>
            <div class="dd__pagination">
                <button
                    class="dd__page-btn"
                    [disabled]="currentPage === 0"
                    (click)="prevPage()"
                    aria-label="Previous page">
                    <span class="material-icons-outlined">chevron_left</span>
                </button>
                <span class="dd__page-label">{{ currentPage + 1 }} / {{ totalPages }}</span>
                <button
                    class="dd__page-btn"
                    [disabled]="currentPage >= totalPages - 1"
                    (click)="nextPage()"
                    aria-label="Next page">
                    <span class="material-icons-outlined">chevron_right</span>
                </button>
            </div>
        </div>

    </ng-container>

    <!-- ══════════════════════════════════════════════════════════════════════
         FEEDBACK VIEW — scrollable cards
    ══════════════════════════════════════════════════════════════════════════ -->
    <ng-container *ngIf="data.type === 'feedback'">

        <div class="dd__body dd__body--cards">

            <div *ngFor="let item of filteredItems" class="dd__card">

                <!-- Question (left) + user avatar/name (right) -->
                <div class="dd__card-top">
                    <p class="dd__question">{{ item.question }}</p>
                    <div class="dd__user-tag">
                        <span class="dd__avatar dd__avatar--sm">{{ getInitials(item.user_name) }}</span>
                        <span class="dd__username">{{ item.user_name }}</span>
                    </div>
                </div>

                <div class="dd__divider"></div>

                <!-- Comment + stars + date -->
                <div class="dd__card-body">
                    <p class="dd__comment">"{{ item.feedback.additional_comments }}"</p>
                    <div class="dd__card-meta">
                        <div class="dd__stars" *ngIf="item.feedback.response_rating">
                            <span *ngFor="let filled of getRatingStars(item.feedback.response_rating)"
                                  class="material-icons-outlined dd__star"
                                  [class.dd__star--on]="filled">star</span>
                        </div>
                        <span class="dd__date">{{ formatDate(item.feedback.submitted_at) }}</span>
                    </div>
                </div>

            </div>

            <div class="dd__empty" *ngIf="filteredItems.length === 0">
                <span class="material-icons-outlined">chat_bubble_outline</span>
                <p>No feedback comments found.</p>
            </div>

        </div>

    </ng-container>

    <!-- ══════════════════════════════════════════════════════════════════════
         QUESTIONS VIEW — scrollable cards with question text
    ══════════════════════════════════════════════════════════════════════════ -->
    <ng-container *ngIf="data.type === 'questions'">

        <div class="dd__body dd__body--cards">

            <div *ngFor="let item of filteredQuestionItems; let i = index" class="dd__question-card">
                <div class="dd__question-header">
                    <div class="dd__question-number">#{{ i + 1 }}</div>
                    <span class="dd__question-user">
                        <span class="material-icons-outlined">person</span>
                        {{ item.user_email }}
                    </span>
                </div>
                <p class="dd__question-text">{{ item.question }}</p>
            </div>

            <div class="dd__empty" *ngIf="filteredQuestionItems.length === 0">
                <span class="material-icons-outlined">question_answer</span>
                <p>No questions found for the selected filters.</p>
            </div>

        </div>

    </ng-container>

    <!-- ══════════════════════════════════════════════════════════════════════
         CONSOLIDATED VIEW — paginated manager stats table
    ══════════════════════════════════════════════════════════════════════════ -->
    <ng-container *ngIf="data.type === 'consolidated'">

        <div class="dd__body">
            <table class="dd__table dd__table--consolidated" aria-label="Consolidated manager statistics">
                <colgroup>
                    <col />
                    <col />
                    <col />
                    <col />
                </colgroup>
                <thead>
                    <tr>
                        <th class="dd__th">Manager Name</th>
                        <th class="dd__th">No. of Users Have Access</th>
                        <th class="dd__th">No. of Active Users</th>
                        <th class="dd__th">Total Feedback Count</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of pagedManagerStats" class="dd__row">
                        <td class="dd__td">{{ item.manager_name || '-' }}</td>
                        <td class="dd__td">{{ item.total_users_under_manager }}</td>
                        <td class="dd__td">{{ item.active_users }}</td>
                        <td class="dd__td">{{ item.total_feedback_count }}</td>
                    </tr>
                </tbody>
            </table>

            <div *ngIf="pagedManagerStats.length === 0" class="dd__empty">
                <span class="material-icons-outlined">table_view</span>
                <p>No manager statistics available.</p>
            </div>
        </div>

        <div class="dd__footer" *ngIf="consolidatedTotalCount > 0">
            <span class="dd__range">Showing {{ consolidatedRangeStart }}–{{ consolidatedRangeEnd }} of {{ consolidatedTotalCount }}</span>
            <div class="dd__pagination">
                <button
                    class="dd__page-btn"
                    [disabled]="consolidatedCurrentPage === 0"
                    (click)="prevConsolidatedPage()"
                    aria-label="Previous page">
                    <span class="material-icons-outlined">chevron_left</span>
                </button>
                <span class="dd__page-label">{{ consolidatedCurrentPage + 1 }} / {{ consolidatedTotalPages }}</span>
                <button
                    class="dd__page-btn"
                    [disabled]="consolidatedCurrentPage >= consolidatedTotalPages - 1"
                    (click)="nextConsolidatedPage()"
                    aria-label="Next page">
                    <span class="material-icons-outlined">chevron_right</span>
                </button>
            </div>
        </div>

    </ng-container>

</div>
